import { call, put, takeEvery } from "redux-saga/effects";

import { FETCH_TOS_BY_JOB_ID_AND_CANDIDATE_ID } from "./actionTypes";
import {
  fetchTosByJobIdAndCandidateIdSuccess,
  fetchTosByJobIdAndCandidateIdFailure,
} from "./action";
import { getTosByJobIdAndCandidateId } from "../../helpers/backend_helper";
import { toast } from "react-toastify";

function* workFetchTosByJobIdAndCandidateId(action) {
  const { jobId, candidateId, status } = action.payload;
  try {
    const response = yield call(
      getTosByJobIdAndCandidateId,
      jobId,
      candidateId,
      status
    );
    yield put(fetchTosByJobIdAndCandidateIdSuccess(response.data));
  } catch (error) {
    yield put(fetchTosByJobIdAndCandidateIdFailure(error));
    toast.error("Failed to fetch TOS");
  }
}

export default function* watchFetchTosSaga() {
  yield takeEvery(
    FETCH_TOS_BY_JOB_ID_AND_CANDIDATE_ID,
    workFetchTosByJobIdAndCandidateId
  );
}
